import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { VoucherCategory, } from '@debbie/common/dist/economy/vouchers/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import { useBillingModels } from '@debbie/cortex/dist/billing-models/index.js';
import { selectVoucherTypes } from '@debbie/cortex/dist/economy/selectors.js';
import { MoneyInput } from '../../index.js';
import FilterGroup from '../FilterGroup.js';
import FilterOption from '../FilterOption.js';
import { useBillingAppendixSetups } from '@debbie/cortex/dist/billing-appendix-setups/index.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import { TenantType } from '@debbie/common/dist/tenants/index.js';
let tid = null;
const EconomyGroup = (props) => {
    const { caseFilter } = props;
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const billingModelsLoadable = useBillingModels();
    const billingModels = h.hasData(billingModelsLoadable) && billingModelsLoadable.data;
    const billingAppendixSetupsLoadable = useBillingAppendixSetups();
    const billingAppendixSetups = h.hasData(billingAppendixSetupsLoadable) &&
        billingAppendixSetupsLoadable.data;
    const voucherTypes = useSelector(selectVoucherTypes);
    const [economyMinBalanceValue, setEconomyMinBalanceValue] = useState(typeof caseFilter.economyMinBalance === 'number'
        ? caseFilter.economyMinBalance
        : null);
    const [economyMaxBalanceValue, setEconomyMaxBalanceValue] = useState(typeof caseFilter.economyMaxBalance === 'number'
        ? caseFilter.economyMaxBalance
        : null);
    useEffect(() => {
        // Max
        if (caseFilter.economyMaxBalance != economyMaxBalanceValue) {
            setEconomyMaxBalanceValue(caseFilter.economyMaxBalance || null);
        }
        // Min
        if (caseFilter.economyMinBalance != economyMinBalanceValue) {
            setEconomyMinBalanceValue(caseFilter.economyMinBalance || null);
        }
    }, [caseFilter.economyMinBalance, caseFilter.economyMaxBalance]);
    useEffect(() => {
        if (!voucherTypes) {
            c.economy.getVoucherTypes();
        }
    }, []);
    return (React.createElement(FilterGroup, { name: lang.caseFilter.economyGroup },
        React.createElement(FilterOption, { active: !!caseFilter.economyOnlyVoucherTypeIds?.length, header: lang.caseFilter.economyOnlyVoucherTypeIds, onDeactivate: () => c.insights.clearFilter('economyOnlyVoucherTypeIds') },
            React.createElement(Select, { value: (caseFilter.economyOnlyVoucherTypeIds || []).map((voucherTypeId) => {
                    const voucherType = voucherTypes?.find((vT) => vT.voucherTypeId === voucherTypeId);
                    return {
                        label: lang.economyVoucherTypeLabels[voucherTypeId] ||
                            voucherType?.label ||
                            voucherTypeId,
                        value: voucherTypeId,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.economyOnlyVoucherTypeIds, classNamePrefix: "select", options: (voucherTypes || [])
                    .filter((voucherType) => [
                    VoucherCategory.COST,
                    VoucherCategory.COURTCOST,
                    VoucherCategory.INTEREST,
                    VoucherCategory.PRINCIPAL,
                    VoucherCategory.TRANSACTION,
                ].includes(voucherType.category))
                    .map((voucherType) => ({
                    label: lang.economyVoucherTypeLabels[voucherType.voucherTypeId] ||
                        voucherType.label,
                    value: voucherType.voucherTypeId,
                })), onChange: async (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    if (selected.length) {
                        c.insights.updateFilter({
                            economyOnlyVoucherTypeIds: selected,
                        });
                    }
                    else {
                        c.insights.clearFilter('economyOnlyVoucherTypeIds');
                    }
                } }),
            React.createElement("br", null)),
        React.createElement(FilterOption, { active: typeof caseFilter.economyMinBalance === 'number', header: lang.caseFilter.economyMinAmount, onDeactivate: () => c.insights.clearFilter('economyMinBalance') },
            React.createElement(MoneyInput, { placeholder: lang.caseFilter.economyMinAmount, value: economyMinBalanceValue, allowNull: true, onChange: (amount) => {
                    setEconomyMinBalanceValue(amount);
                    clearTimeout(tid);
                    console.log(amount);
                    tid = setTimeout(() => {
                        if (typeof amount === 'number') {
                            c.insights.updateFilter({
                                economyMinBalance: amount,
                            });
                        }
                        else {
                            c.insights.clearFilter('economyMinBalance');
                        }
                    }, 500);
                } })),
        React.createElement(FilterOption, { active: typeof caseFilter.economyMaxBalance === 'number', header: lang.caseFilter.economyMaxAmount, onDeactivate: () => c.insights.clearFilter('economyMaxBalance') },
            React.createElement(MoneyInput, { placeholder: lang.caseFilter.economyMaxAmount, value: economyMaxBalanceValue, allowNull: true, onChange: (amount) => {
                    setEconomyMaxBalanceValue(amount);
                    clearTimeout(tid);
                    tid = setTimeout(() => {
                        if (typeof amount === 'number') {
                            c.insights.updateFilter({
                                economyMaxBalance: amount,
                            });
                        }
                        else {
                            c.insights.clearFilter('economyMaxBalance');
                        }
                    }, 500);
                } })),
        tenant?.type === TenantType.Agency ? (React.createElement(FilterOption, { active: !!(caseFilter.billingModelIds && caseFilter.billingModelIds.length), header: lang.caseFilter.economyBillingModels, onDeactivate: () => c.insights.clearFilter('billingModelIds') },
            React.createElement(Select, { value: (caseFilter.billingModelIds || []).map((id) => {
                    const billingModel = billingModels
                        ? billingModels.find((billingModel) => billingModel.billingModelId === id)
                        : undefined;
                    return { label: billingModel?.name, value: id };
                }), isMulti: true, placeholder: lang.caseFilter.billingModels, classNamePrefix: "select", options: (billingModels || [])
                    .filter((billingAppendixSetup) => !billingAppendixSetup.archived)
                    .map((billingModel) => ({
                    label: billingModel.name,
                    value: billingModel.billingModelId,
                })), onChange: async (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        billingModelIds: selected.length ? selected : undefined,
                    });
                } }))) : null,
        tenant?.type === TenantType.Agency ? (React.createElement(FilterOption, { active: !!(caseFilter.billingAppendixSetupIds &&
                caseFilter.billingAppendixSetupIds.length), header: lang.caseFilter.economyBillingAppendixSetups, onDeactivate: () => c.insights.clearFilter('billingAppendixSetupIds') },
            React.createElement(Select, { value: (caseFilter.billingAppendixSetupIds || []).map((id) => {
                    const billingAppendixSetup = billingAppendixSetups
                        ? billingAppendixSetups.find((billingAppendixSetup) => billingAppendixSetup.billingAppendixSetupId === id)
                        : undefined;
                    return { label: billingAppendixSetup?.name, value: id };
                }), isMulti: true, placeholder: lang.caseFilter.economyBillingAppendixSetups, classNamePrefix: "select", options: (billingAppendixSetups || [])
                    .filter((billingAppendixSetup) => !billingAppendixSetup.archived)
                    .map((billingAppendixSetup) => ({
                    label: billingAppendixSetup.name,
                    value: billingAppendixSetup.billingAppendixSetupId,
                })), onChange: async (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        billingAppendixSetupIds: selected.length ? selected : undefined,
                    });
                } }))) : null));
};
export default EconomyGroup;
//# sourceMappingURL=EconomyGroup.js.map